export const INSTALMENT_PLAN_IDENTIFIER_NAME = 'instalmentPlanId';
export const PAYMENT_IDENTIFIER_NAME = 'paymentId';
export const SUBSCRIPTION_IDENTIFIER_NAME = 'subscriptionId';
export const PAYMENT_METHOD_GROUP_IDENTIFIER_NAME = 'paymentMethodGroupId';
